import React from 'react';
import Switch from '@material-ui/core/Switch';
import { SimpleFlexContainer as Container } from '../layouts/ng-layouts/Containers';
import useTranslations from '../../hooks/useTranslations';
import styled from 'styled-components/macro';
import Checkbox from '@material-ui/core/Checkbox';
import Colors from '../../internal-components/Colors';

const PermissionRow = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px dashed ${Colors.BORDER_GREY};
  position: relative;
  height: 39px;

  span[class*='MuiSwitch'] {
    margin-left: auto;
  }
`;

const PermissionDescription = styled.span``;

const AllowForLabelContainer = styled.div`
  left: 580px;
  position: absolute;
`;

const AllowForLabel = styled.div`
  padding-left: 33px;
`;

const StyledLabel = styled.label`
  color: ${({ disabled }) => (disabled ? '#bdbdbd' : 'inherit')};
  padding-left: 20px;
`;

const FormBuilderSharePermissionsView = props => {
  const t = useTranslations();
  return (
    <Container>
      <PermissionRow>
        <AllowForLabelContainer>
          {props.externalUsersLicense && (<AllowForLabel>
            {t('form-builder.share.allow')}
          </AllowForLabel>)}
        </AllowForLabelContainer>
      </PermissionRow>
      <PermissionRow>
        <PermissionDescription>
          {t('form-builder.share.reassign')}
        </PermissionDescription>
        <AllowForLabelContainer>
          <StyledLabel>
            <Checkbox
              color="primary"
              checked={props.currentPermissions.internal.allowEntriesReassignment}
              onChange={e => props.togglePermissions('allowEntriesReassignment', 'internal', e.target.checked)}
              data-testid='permission-reassign-internal'
            />
            {props.externalUsersLicense && t('form-builder.share.internal')}
          </StyledLabel>
        </AllowForLabelContainer>
      </PermissionRow>

      <PermissionRow>
        <PermissionDescription>
          {t('form-builder.share.share')}
        </PermissionDescription>
        <AllowForLabelContainer>
          <StyledLabel>
            <Checkbox
              color="primary"
              checked={!props.currentPermissions.internal.disableSharing}
              onChange={e => props.togglePermissions('disableSharing', 'internal', !e.target.checked)}
              data-testid='permission-share-internal'
            />
            {props.externalUsersLicense && t('form-builder.share.internal')}
          </StyledLabel>
        </AllowForLabelContainer>
      </PermissionRow>

      <PermissionRow>
        <PermissionDescription>
          {t('form-builder.share.create')}
        </PermissionDescription>
        <AllowForLabelContainer>
          <StyledLabel>
            <Checkbox
              color="primary"
              checked={props.currentPermissions.internal.allowUsersToCreateNewSubmissions}
              onChange={e => props.togglePermissions('allowUsersToCreateNewSubmissions', 'internal', e.target.checked)}
              data-testid='permission-create-internal'
            />
            {props.externalUsersLicense && t('form-builder.share.internal')}
          </StyledLabel>
          {props.externalUsersLicense && (
          <StyledLabel disabled={!props.allowExternalUserAccounts}>
            <Checkbox
              color="primary"
              checked={props.currentPermissions.external.allowUsersToCreateNewSubmissions}
              onChange={e => props.togglePermissions('allowUsersToCreateNewSubmissions', 'external', e.target.checked)}
              disabled={!props.allowExternalUserAccounts}
              data-testid='permission-create-external'
            />
            {t('form-builder.share.external')}
          </StyledLabel>
          )}
        </AllowForLabelContainer>
      </PermissionRow>

      {props.externalUsersLicense && (
      <PermissionRow>
        <PermissionDescription>
          {t('form-builder.share.invite_external')}
        </PermissionDescription>
        <AllowForLabelContainer>
          <StyledLabel disabled={!props.allowExternalUserAccounts}>
            <Checkbox
              color="primary"
              checked={props.currentPermissions.internal.allowUsersToInviteExternalPeople}
              onChange={e => props.togglePermissions('allowUsersToInviteExternalPeople', 'internal', e.target.checked)}
              disabled={!props.allowExternalUserAccounts}
              data-testid='permission-invite-internal'
            />
            {t('form-builder.share.internal')}
          </StyledLabel>
          <StyledLabel disabled={!props.allowExternalUserAccounts}>
            <Checkbox
              color="primary"
              checked={props.currentPermissions.external.allowUsersToInviteExternalPeople}
              onChange={e => props.togglePermissions('allowUsersToInviteExternalPeople', 'external', e.target.checked)}
              disabled={!props.allowExternalUserAccounts}
              data-testid='permission-invite-external'
            />
            {t('form-builder.share.external')}
          </StyledLabel>
        </AllowForLabelContainer>
      </PermissionRow>
      )}

    </Container>
  );
};

export default FormBuilderSharePermissionsView;
